export { traditions, traditionsBySlug } from './traditions';
export { experiences, experiencesBySlug } from './experiences';
export { eats, eatsBySlug } from './eats';

export const cadenceLabels = {
  weekly: 'Every Friday',
  monthly: 'Monthly',
  recurring: 'Recurring',
  annual: 'Every Year',
};

export const categoryLabels = {
  activity: 'Activity',
  competition: 'Competition',
  'team-dinner': 'Team Dinner',
  'happy-hour': 'Happy Hour',
  'sporting-event': 'Sporting Event',
  volunteer: 'Volunteer',
  celebration: 'Celebration',
  family: 'Family',
  learning: 'Learning',
  other: 'Other',
};

export function formatCultureDate(date, precision = 'day') {
  if (!date) return '';
  const parsed = new Date(`${date}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return '';
  if (precision === 'year') return String(parsed.getFullYear());
  return new Intl.DateTimeFormat('en-US', precision === 'month'
    ? { month: 'long', year: 'numeric' }
    : { month: 'long', day: 'numeric', year: 'numeric' }).format(parsed);
}
